import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import ProductContainer from './productContainer';
import useEmblaCarousel from 'embla-carousel-react'
import { scaleInCenter } from './styled/animations';
import Lottie from 'lottie-react';
import LightAnimation from '../assets/animations/light.json';

const ProductSlider = ({ products }) => {
      const [loadImage, setLoadImage] = useState(false);
      const [scaleFactor, setScaleFactor] = useState(1);
      const [currentIndex, setCurrentIndex] = useState(0);
      const lottieRef = useRef();
      const startSwipePoint = useRef(0);
      const OPTIONS = { 
        align: 'center',
        duration: 20,
      }
    
      const [emblaRef, emblaApi] = useEmblaCarousel(OPTIONS)
      React.useEffect(() => {
        if (!emblaApi) return;
        const onSelect = () => {
          setCurrentIndex(emblaApi.selectedScrollSnap());
        };
        emblaApi.on('select', onSelect);
        onSelect();
            if (lottieRef.current) {
              lottieRef.current?.setSpeed(0.5);
            }
      }, [emblaApi]);

      const calculateCardPositions = () => {
        const maxWidth = 200;
        const baseOffset = 100;
        return products.map((_, index) => {
          const width = maxWidth - Math.abs(currentIndex - index) * 30;
          const scaleFactor = width / maxWidth;
          const translateX = (index - currentIndex) * baseOffset * scaleFactor;
    
          return { translateX };
        });
      };


      const onEndTouch = (clientX) => {
        let endSwipe = clientX;
            if (
              startSwipePoint.current > endSwipe &&
              currentIndex < products.length - 1
            ) {
              setCurrentIndex(currentIndex + 1);
              emblaApi.scrollTo(currentIndex + 1);
            } else if (currentIndex > 0) {
              emblaApi.scrollTo(currentIndex - 1);
              setCurrentIndex(currentIndex - 1);
            }
      }
      useEffect(() => {
        const referenceWidth = 414;
        const referenceHeight = 896;
        const scaleWidth = window.innerWidth / referenceWidth;
        const scaleHeight = window.innerHeight / referenceHeight;
        const scaleFactor = Math.min(scaleWidth, scaleHeight);
        setScaleFactor(scaleFactor);
      }, []);

      return(
        <Viewport  ref={emblaRef}>
        <Container>
          {React.Children.toArray(
           products.map((product, index) => (
              <Slide key={index}>
                <ProductContainer product={product} />
              </Slide>
            ))
          )}
        </Container>
        <ButtonWrapper>
        <PrevButton onClick={() => emblaApi && emblaApi.scrollPrev()}>
          Prev
        </PrevButton>
        <NextButton onClick={() => emblaApi && emblaApi.scrollNext()}>
          Next
        </NextButton>
      </ButtonWrapper>
      </Viewport>
      )
    return (
      <>
      <ImageContainer
        onMouseDown={(e)=> (startSwipePoint.current = e.clientX)}
        onMouseUp={(e)=> onEndTouch(e.clientX)}
        onTouchEnd={(e) => {
          onEndTouch(e.changedTouches[0].clientX)
        }}
        style={{ width: "100%", height: "100%" }}
        onTouchStart={(e) => (startSwipePoint.current = e.touches[0].clientX)}
      >
      {/* <Lottie
          lottieRef={lottieRef}
          style={{ position: "absolute", zIndex: products.length  , opacity: loadImage? 1: 0 }}
          animationData={LightAnimation}
        /> */}
        {/* {React.Children.toArray(
        products.map((item, index) => {
          const { translateX } = calculateCardPositions()[index];

          return (
            <Card
              key={item.id}
              style={{
                zIndex: products.length - Math.abs(currentIndex - index),
                width:
                  Math.abs(169 - Math.abs(currentIndex - index) * 50) * scaleFactor,
                height:
                  Math.abs(292 - Math.abs(currentIndex - index) * 50) * scaleFactor,
                transform: `translateX(${translateX}px)`,
                minHeight:"20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Image draggable={false} onLoad={()=> setLoadImage(true)} src={item.item.imageUri} />
            </Card>
          );
        }))} */}
        </ImageContainer>
        <Viewport  ref={emblaRef}>
        <Container>
          {React.Children.toArray(
           products.map((product, index) => (
              <Slide key={index}>
                <ProductContainer product={product} />
              </Slide>
            ))
          )}
        </Container>
      </Viewport>
      </>
    );
}
const Container = styled.div`
  display: flex;
  align-items: center;
  backface-visibility: hidden;
  height: 100%;
`
const Slide = styled.div`
  flex: 0 0 100%;
  min-width: 0;
  position: relative;
  padding: 0 8px;
  height: 100%;
`
const Viewport = styled.div`
  width: 100%;
`
const ButtonWrapper = styled.div`
  position: absolute;
  top: 60%;
  width: 100%;
  display: flex;
  justify-content: space-between;
  transform: translateY(-60%);
  left: 0;
  pointer-events: none;
  padding:0 16px; /* Allows clicks on buttons only */
`;

const PrevButton = styled.button`
  pointer-events: all;
  background: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(50px);
  -webkit-backdrop-filter: blur(50px);
  border: none;
  color: white;
  padding: 16px 16px;
  cursor: pointer;
  border-radius: 8px;
`;

const NextButton = styled.button`
  pointer-events: all;
  background: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(50px);
  -webkit-backdrop-filter: blur(50px);
  border: none;
  color: white;
  border-radius: 8px;
  padding: 16px 16px;
  cursor: pointer;
`;

const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Image = styled.img`
  width: 100%;
  scale: 1.1;
  height: 100%;
  object-fit: contain;
  animation: ${scaleInCenter} 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  -webkit-animation: ${scaleInCenter} 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)
    both;
`;

const Card = styled.div`
  transition: all 0.3s ease;
  position: absolute;
  user-select: none;
`;
export default ProductSlider;